import { FC, useEffect, useState } from "react";
import { DateTime } from "luxon";
import { getCurrentEstTime } from "@/pages/overwolf/components/OverwolfGoVipChallengesCard";

interface Props {
    challengeStart: number;
}

export const BrandChallengeCountdown: FC<Props> = ({ challengeStart }) => {
    const [currentTime, setCurrentTime] = useState(getCurrentEstTime());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(getCurrentEstTime());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Calculate time difference
    const now = DateTime.fromMillis(currentTime).setZone("America/New_York");
    const start = DateTime.fromMillis(challengeStart).setZone("America/New_York");
    const diff = start.diff(now, ["days", "hours", "minutes", "seconds"]);

    // Don't show if challenge has already started
    if (challengeStart <= Date.now()) {
        return null;
    }

    const days = Math.floor(diff.days || 0);
    const hours = Math.floor(diff.hours || 0);
    const minutes = Math.floor(diff.minutes || 0);
    const seconds = Math.floor(diff.seconds || 0);

    return (
        <div className="brand-challenge-countdown">
            <div className="brand-challenge-countdown_content">
                <h4 className="brand-challenge-countdown_title">Challenge Starts In</h4>
                <div className="brand-challenge-countdown_timer">
                    {days > 0 &&
                        <div className="brand-challenge-countdown_unit">
                            <span className="brand-challenge-countdown_value">{days}</span>
                            <span className="brand-challenge-countdown_label">Days</span>
                        </div>
                    }
                    <div className="brand-challenge-countdown_unit">
                        <span className="brand-challenge-countdown_value">{hours.toString().padStart(2, "0")}</span>
                        <span className="brand-challenge-countdown_label">Hours</span>
                    </div>
                    <div className="brand-challenge-countdown_unit">
                        <span className="brand-challenge-countdown_value">{minutes.toString().padStart(2, "0")}</span>
                        <span className="brand-challenge-countdown_label">Minutes</span>
                    </div>
                    <div className="brand-challenge-countdown_unit">
                        <span className="brand-challenge-countdown_value">{seconds.toString().padStart(2, "0")}</span>
                        <span className="brand-challenge-countdown_label">Seconds</span>
                    </div>
                </div>
            </div>
        </div>
    );
};